"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enCommonTranslations = void 0;
/* eslint-disable */
exports.enCommonTranslations = {
    product: {
        customer: 'Customer',
        selectCustomer: 'Select customer',
        addProduct: 'Add product',
        removeProduct: 'Remove product',
        createProductList: 'Create product list',
        scaleNumber: 'Scale number',
        price: 'Price',
        country: 'Country of origin',
        packageSize: 'Package size',
        packageUnit: 'Unit',
        sellingUnit: 'Sales unit',
        sellingPrice: 'Sales price',
        discount: 'Discount',
        class: 'Class',
        description: 'Description',
        imageNotFound: 'Image not found',
        packageUnitTooltip: 'Packaging unit represents the size of the whole package, e.g 500 g. Empty for scaled products',
        sellingUnitTooltip: 'The selling unit of the product, together with price e.g 1.49€ / kg',
        productImage: 'Product image',
        details: 'Product details',
        delete: 'Delete product',
        deleteConfirm: 'Are you sure you want to remove {{name}}? This action cannot be undone.',
        selectTemplate: 'Template',
        discountPrice: 'Discount price',
        discountValid: 'Discount valid',
        discountValidHelper: 'eg. \'Discount valid 2.5-2.6.2020\'',
        comparisonUnit: 'Comparison unit',
        comparisonUnitHelper: 'Comparison unit, e.g 1,90€ / kg',
        discountBatch: 'Batch discount',
        discountBatchHelper: 'Amount, if e.g 3 for 5€',
        deposit: 'Deposit',
        depositHelper: 'If a product with a deposit',
        tags: 'Tags',
        tag: {
            organic: 'Organic',
            local: 'Local',
            discount: 'Discount'
        },
        selectOneTag: 'Select only one*',
        isPrefilled: "Product data has been prefilled. Make sure that values are correct."
    }
};
//# sourceMappingURL=en.js.map